import {
    Component,
    ChangeDetectionStrategy,
    HostBinding,
    ViewChild,
    ElementRef,
    HostListener,
    AfterViewInit,
    Input,
    EventEmitter,
    Output,
} from '@angular/core';
import { isMobile } from '@ui/shared/ui-common';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-filter-container',
    templateUrl: './filter-container.component.html',
    styleUrls: ['./filter-container.component.scss'],
    standalone: false,
})
export class FilterContainerComponent implements AfterViewInit {
    @ViewChild('FilterScrollContent')
    public filterScrollContent?: ElementRef<HTMLElement>;

    @ViewChild('FilterScrollShadows')
    public filterScrollShadows?: ElementRef<HTMLElement>;

    @ViewChild('ShowFiltersButton')
    public showFiltersButton?: ElementRef<HTMLButtonElement>;

    @HostBinding('class.dynamic-columns')
    @Input()
    public dynamicColumns = false;

    @Output()
    public readonly toggledFilters = new EventEmitter<boolean>();

    private _showOtherFilters = false;

    public get isMobile(): boolean {
        return isMobile();
    }

    @HostBinding('class.mobile-expanded')
    public get showOtherFilters(): boolean {
        return this._showOtherFilters;
    }

    public set showOtherFilters(value) {
        this._showOtherFilters = value;
        this.toggledFilters.emit(value);

        if (this._showOtherFilters) {
            // Whenever the other filters are activated, update their scroll shadow in the next frame.
            requestAnimationFrame(() => {
                this.updateScrollShadows();
            });
        }

        // Whenever the filters are toggled, re-focus the toggle button in the next frame (because it changes position)
        requestAnimationFrame(() => {
            this.showFiltersButton?.nativeElement.focus();
        });
    }

    /**
     * Set the opacity of the scroll shadows depending on the scrolling distance to the top or bottom respectively.
     * The opacity is the pixel distance in percent, so it fades in/out between 0 and 100px, then remains at 100%.
     */
    @HostListener('window:resize')
    public updateScrollShadows(): void {
        const scrollElement = this.filterScrollContent?.nativeElement;
        const shadowsElement = this.filterScrollShadows?.nativeElement;

        if (!scrollElement || !shadowsElement) {
            return;
        }

        const scrollRange = scrollElement.scrollHeight - scrollElement.offsetHeight;
        const scrollTopDistance = scrollElement.scrollTop;
        const scrollBottomDistance = scrollRange - scrollElement.scrollTop;
        const percent = 0.01;

        shadowsElement.style.setProperty('--scroll-shadow-top-opacity', `${ scrollTopDistance * percent }`);
        shadowsElement.style.setProperty('--scroll-shadow-bottom-opacity', `${ scrollBottomDistance * percent }`);
    }

    public onScrollFilter(): void {
        this.updateScrollShadows();
    }

    public ngAfterViewInit(): void {
        this.updateScrollShadows();
    }
}
